import React, { forwardRef } from 'react';
import DatePicker, {
  ReactDatePickerProps,
} from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { customCalendarHeader } from './common/customCalendarHeader';

interface CustomDatePickerProps
  extends ReactDatePickerProps {
  onVisibleMonthChange?: (date: Date) => void;
}

const CustomDatePicker = forwardRef(
  (
    {
      onVisibleMonthChange,
      ...props
    }: CustomDatePickerProps,
    ref:
      | React.LegacyRef<DatePicker<never, undefined>>
      | undefined
  ) => {
    return (
      <DatePicker
        dateFormat={
          props.showTimeSelect
            ? 'dd/MM/yyyy, h:mm a'
            : 'dd/MM/yyyy'
        }
        {...props}
        ref={ref}
        renderCustomHeader={(params) => {
          onVisibleMonthChange?.(params.date);
          return customCalendarHeader(params);
        }}
        onMonthChange={(date) => {
          onVisibleMonthChange?.(date);
        }}
      />
    );
  }
);

CustomDatePicker.defaultProps = {
  formatWeekDay: (nameOfDay) => nameOfDay.substr(0, 1),
  renderCustomHeader: customCalendarHeader,
};

CustomDatePicker.displayName = 'CustomDatePicker';

export default CustomDatePicker;
